import React from "react";
import { Spinner } from "react-bootstrap";
import "../css/FullScreenSpinner.css";

const LoginSpinner = ({ isSubmitting }) => {
  if (isSubmitting) {
    return (
      <div className="fullScreenSpinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }
  return null;
};

export default LoginSpinner;
